import { useNavigate } from 'react-router-dom';

import { ActionPanel, Box } from '@thirdspacelearning/library';

import notFoundSvg from '@assets/not-found.svg';

const sx = {
    actionPanel: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexGrow: 1,
    },
};

const RedirectActionPanel = () => {
    const navigate = useNavigate();

    const onRedirect = () => {
        navigate('/');
    };

    return (
        <Box sx={sx.actionPanel}>
            <ActionPanel
                type="error"
                decoration={<img src={notFoundSvg} alt="404 Page not found" />}
                title="Something doesn't add up"
                textContent="We couldn't find the page you were looking for"
                buttonLabel="Return home"
                buttonAction={onRedirect}
                sx={{ maxWidth: '435px' }}
            />
        </Box>
    );
};

export default RedirectActionPanel;
